export default class Geocoder {

    static geocodePoint(lat, lng, callback) {
        let geocoder = new google.maps.Geocoder;

        geocoder.geocode({'location': {lat: lat, lng: lng}}, (results, status) => {
            if (status === google.maps.GeocoderStatus.OK) {
                const result = results[0];

                if (result) {
                    let address = result.formatted_address;
                    callback(result)
                } else {
                    console("error");
                }
            } else {
                console.log('Geocoder failed due to: ' + status);
            }
        });
    }
}